import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import SimpleThread from '../SimpleThread';
import { COMMENT_MODAL_THREAD_MAX_DEPTH } from '../../constants';
import s from './ModalThread.scss';
const ModalThread = (props)=>{
    return /*#__PURE__*/ React.createElement(SimpleThread, _extends({}, props, {
        scrollableClassName: s['scrollable'],
        commentClassName: s['comment'],
        commentWrapperClassName: s['comment-wrapper'],
        viewRepliesClassName: s['view-replies-wrapper'],
        maxDepthOverride: COMMENT_MODAL_THREAD_MAX_DEPTH,
        replyIndentModifier: 1
    }));
};
ModalThread.displayName = 'ModalThread';
export default ModalThread;
